import { modalClubConfig } from './modalClubConfig';

//サイトURLを取得
const locationOrigin = window.location.origin;

//.c-modal_box作成
export function modalClub(id) {
  const clubData = modalClubConfig();
  const targetData = clubData.find((x) => x.id === id);

  //該当するクラブがないとき
  if (!targetData) {
    console.error(`Club with ID ${id} not found.`);
    return null;
  }

  const modalCreate = createModalContent(targetData);
  return modalCreate;
}

//.c-modal_boxの切り替え
export function modalClubUpdate(el, val) {
  const clubData = modalClubConfig();
  const currentId = el.dataset.value;
  const currentIndex = clubData.findIndex((club) => club.id === currentId);

  //該当するクラブがないとき
  if (currentIndex === -1) {
    console.error('指定されたIDのクラブが見つかりませんでした');
    return;
  }

  //prevのときは一つ前のクラブ、nextの時が一つ後のクラブのインデックス番号を取得
  const newIndex = val === 'prev' ? (currentIndex - 1 + clubData.length) % clubData.length : (currentIndex + 1) % clubData.length;

  const selectedClub = clubData[newIndex];
  const newModalContent = createModalContent(selectedClub);

  //既存の.c-modal_boxと切り替える
  if (el.parentNode) {
    el.parentNode.replaceChild(newModalContent, el);
  }
}

// 各パーツを生成する共通関数
function createModalContent(clubData) {
  const modalCreate = document.createElement('div');
  modalCreate.className = 'c-modal_box';
  modalCreate.dataset.value = clubData.id;

  const unitCreate = document.createElement('div');
  unitCreate.className = 'l-pageUnit';

  titleCreate(unitCreate, clubData.name);
  picCreate(unitCreate, clubData.pic);
  textCreate(unitCreate, clubData.text);
  recordCreate(unitCreate, clubData.record);
  snsCreate(unitCreate, clubData.sns);

  modalCreate.appendChild(unitCreate);
  return modalCreate;
}

// タイトル生成
function titleCreate(parent, name) {
  const elCreate = document.createElement('div');
  elCreate.className = 'l-pageUnit_heading';
  elCreate.innerHTML = `<h2 class="c-headingSize24 c-headingLine">${name}</h2>`;
  parent.appendChild(elCreate);
}

// 画像リスト生成
function picCreate(parent, array) {
  const elCreate = document.createElement('div');
  elCreate.className = 'l-pageUnit_box';

  const picList = document.createElement('ul');
  picList.className = 'p-clubCont_pic';

  array.forEach((element) => {
    const liCreate = document.createElement('li');
    liCreate.className = 'p-clubCont_picItem';
    liCreate.innerHTML = `<img src="${locationOrigin}/wp-content/themes/otemae/assets/img/campuslife/club/${element}" alt="">`;
    picList.appendChild(liCreate);
  });

  elCreate.append(picList);
  parent.appendChild(elCreate);
}

// テキスト生成
function textCreate(parent, text) {
  const elCreate = document.createElement('div');
  elCreate.className = 'l-pageUnit_box';
  elCreate.innerHTML = `<p class="c-textSize15">${text.replace(/\n/g, '<br>')}</p>`;
  parent.appendChild(elCreate);
}

// 実績生成
function recordCreate(parent, text) {
  if (!text) return;

  const elCreate = document.createElement('div');
  elCreate.className = 'l-pageUnit_box';
  elCreate.innerHTML = `<div class="c-boxType04 u-brdSolid u-clrBorder--grayOrchid">
    <p class="c-textSize14">${text}</p>
  </div>`;
  parent.appendChild(elCreate);
}

// SNSリスト生成
function snsCreate(parent, sns) {
  if (Object.values(sns).every((url) => url === '')) return;

  const elCreate = document.createElement('div');
  elCreate.className = 'l-pageUnit_box';

  const snsList = document.createElement('ul');
  snsList.className = 'p-clubCont_sns';

  Object.entries(sns).forEach(([platform, url]) => {
    if (url) {
      const liCreate = document.createElement('li');
      liCreate.className = 'p-clubCont_snsItem';

      let platformText;
      if (platform === 'x') {
        platformText = '公式X';
      } else if (platform === 'instagram') {
        platformText = '公式Instagram';
      } else if (platform === 'youtube') {
        platformText = '公式Youtube';
      } else {
        platformText = `公式${platform.charAt(0).toUpperCase() + platform.slice(1)}`;
      }

      liCreate.innerHTML = `<div class="c-btnBasic c-btnBasic--strong">
        <a href="${url}" target="_blank" class="c-btnArrowAfter c-btnArrowAfter--external">
          <span class="c-btnArrowAfter_text">${platformText}</span>
          <span class="c-btnArrowAfter_item"></span>
        </a>
      </div>`;
      snsList.appendChild(liCreate);
    }
  });

  elCreate.appendChild(snsList);
  parent.appendChild(elCreate);
}
